/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/named
import { API_EVENTS /* STAFF_MEMBER_EVENTS */, MEMBERSHIP_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: null,
  error: null,
};

const membershipReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
      // case STAFF_MEMBER_EVENTS.REMOVE_REQUEST:
      return { ...state, loading: true };

    case API_EVENTS.FAIL:
      // case STAFF_MEMBER_EVENTS.REMOVE_FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.SUCCESS:
      // case STAFF_MEMBER_EVENTS.REMOVE_SUCCESS:
      return { ...state, loading: false, data: payload };
    case MEMBERSHIP_EVENTS.DELETE_SUCCESS:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default membershipReducer;
